import { Fragment, useState, useEffect } from "react";
import { Redirect, useHistory } from "react-router-dom";
import { useAppSelector } from "../../app/hooks";
import VideoTutorial from "../../components/VideoTutorial/VideoTutorial";
import { useTranslation } from "react-i18next";

const Success = () => {
    const { t } = useTranslation();

    const chosenMerchant = useAppSelector(
        state => state.voucher.chosenMerchant
    );
    const purchaseStatus = useAppSelector(
        state => state.voucher.purchaseCompleted
    );
    const history = useHistory();
    const purchaseCompleted = purchaseStatus.completed;
    const purchaseResult = purchaseStatus.result;

    const name = chosenMerchant.name;

    useEffect(() => {
        window.addEventListener("popstate", () => {
            history.replace("/");
        });
        return () => {
            window.removeEventListener("popstate", () => {
                history.replace("/");
            });
        };
    }, []);

    if (purchaseResult === "failed" || !purchaseCompleted)
        return <Redirect to={"/"} />;

    return chosenMerchant.sendsVoucherCodes ? (
        <Fragment>
            <img
                className="result-image"
                src="assets/illustrations/success-img.svg"
                alt="message"
            />
            <h2 className="mb-7 ta-c">{t("result.successSendTitle")}</h2>

            <p className="ta-c">{t("result.successSendDescription", { name })}</p>

            <VideoTutorial name={chosenMerchant.name} title={true} />
        </Fragment>
    ) : (
        <Fragment>
            <img
                className="result-image"
                src="assets/illustrations/success-img.svg"
                alt="message"
            />
                <h2 className="mb-7 ta-c">{t("result.successTitle")}</h2>

            <p className="ta-c">{t("result.successDescription", { name })}</p>

            <VideoTutorial name={chosenMerchant.name} title={true} />
        </Fragment>
    );
};

export default Success;
